import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PlaceOrdersService from "../../services/PlaceOrderService";
import {
  listAddress,
  listItems,
  listOrderDetails,
  setIsPaid,
} from "../../stores/order";

import { useNavigate, useParams } from "react-router-dom";
import PaypalButtonComponent from "./PaypalButtonComponent";
function OrderPage(props) {
  const params = useParams();
  const endpoint = `${params.id}`;
  const dispatch = useDispatch();
  const detail = useSelector((state) => state.order.orderdetails);
  const orderitems = useSelector((state) => state.order.items);
  const address = useSelector((state) => state.order.address);
  const isPaid = useSelector((state) => state.order.isPaid);

  useEffect(() => {
    // call Data from api

    PlaceOrdersService.get(endpoint).then((response) => {
      const datas = response.data.data[0];
      // console.log("result " + JSON.stringify(datas));
      // setLoaddata(datas);

      dispatch(
        listOrderDetails({
          id: datas.id,
          paymentmethod: datas.paymentmethod,
          totalprice: datas.totalprice,
          ispaid: datas.ispaid,
          paidat: datas.paidat,
          isdelivered: datas.isdelivered,
          deliveredat: datas.deliveredat,
        })
      );

      // eslint-disable-next-line array-callback-return
      datas.orderitems.map((item) => {
        dispatch(
          listItems({
            productId: item.menu_items_id,
            name: item.name,
            quantity: item.quantity,
            price: item.price,
          })
        );
      });

      // eslint-disable-next-line array-callback-return
      datas.address.map((item) => {
        dispatch(
          listAddress({
            address: item.address,
            city: item.city,
            postcode: item.postcode,
            country: item.country,
            telephone: item.telephone,
          })
        );
      });
    });
  }, [endpoint, dispatch, isPaid]);

  return (
    <div className="container pb-10 pt-14 text-black">
      <div className="sm:flex flex-row-2 my-5 ">
        <div className="sm:w-1/2 justify-center items-center overflow-hidden">
          <h2 className="text-3xl text-left">ORDER #{detail.id}</h2>
          <br /> <br />
          <h3 className="text-2xl text-left">SELF PICK UP</h3>
          {address
            ? address.map((item, key) => (
                <div key={key}>
                  <p className="">Name: {item.postcode}</p>
                  <p className="">Phone: {item.telephone}</p>

                  <p className="">
                    Address: {item.address} {item.city} {item.country}
                  </p>

                  <p className="">
                    {detail.deliveredat === "0" ? (
                      <span className="bg-yellow-400">Not Picked Up</span>
                    ) : (
                      <span className="bg-green-400">Picked Up</span>
                    )}
                  </p>
                </div>
              ))
            : ""}
          <br />
          <h3 className="text-2xl text-left">PAYMENT METHOD</h3>
          <p className="">Payment Method: {detail.paymentmethod}</p>
          <p className="">
            {detail.paidat === "0" ? (
              <span className="bg-yellow-400">Not Paid</span>
            ) : (
              <span className="bg-green-400">Paid</span>
            )}
          </p>
          <br />
          <h3 className="text-2xl text-left">ORDER ITEMS</h3>
          {orderitems
            ? orderitems.map((item, key) => (
                <div
                  className="text-black flex justify-between items-center p-2 border-b-2 gap-5 "
                  key={key}
                >
                  <p className="w-3/4">{item.name}</p>
                  <div className="w-20 flex justify-between gap-2">
                    <span>
                      {item.quantity}x${item.price}
                    </span>
                  </div>
                  <p className="w-1/4">${item.price * item.quantity}</p>
                </div>
              ))
            : ""}
          <div className="text-black flex justify-between items-center p-2 border-b-2 gap-5 bg-green-300 ">
            <p className="w-3/4">Order Total</p>
            <div className="w-20 flex justify-between gap-2">
              <span></span>
            </div>
            <p className="w-1/4">${detail.totalprice}</p>
          </div>
          <br />
        </div>
        <div className={"sm:w-1/2 p-9 bg-slate-100"}>
          <h3 className="text-2xl text-left">ORDER SUMMARY</h3>
          <div className="text-black flex justify-between items-center p-2 border-b-2 gap-5 ">
            <p className="w-3/4">Order Total</p>
            <div className="w-20 flex justify-between gap-2">
              <span></span>
            </div>
            <p className="w-1/4">${detail.totalprice}</p>
          </div>
          {detail.paidat === "0" ? (
            <span className="bg-yellow-400">
              <PaypalButtonComponent />
            </span>
          ) : (
            <span className="bg-green-400">Paid</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default OrderPage;
